<template>
  <VueLoading type="spiningDubbles" color="#6f6f6f" :size="{ width: '80px', height: '80px' }" />
</template>

<script>
import { VueLoading } from 'vue-loading-template';
export default {
  name: 'SpiningDubblesLoading',
  components: {
    VueLoading,
  },
};
</script>
